import HeaderBack from "@/components/fragments/HeaderBack";
import CartFeature from "@/features/Cart";

export default function Cartpage() {
  return (
    <main className="md:w-[80vw] lg:w-[70vw] mx-auto h-screen ">
      <HeaderBack text="Keranjang" url="/catalog" />
      <div className="mt-6">
        <CartFeature />
      </div>
    </main>
  );
}
